import React from "react";
import { navigate } from "gatsby";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import CardNews from "../../atoms/card-news/cardNews";
import LayoutSlider from "../../templates/layout-slider/layoutSlider";
import { ReferenciaPlantillaContenido } from "../../../interfaces/ReferenciaPlantillaContenido";

import "./galleryCards.scss";

const GalleryCards = (props: ReferenciaContenido) => {
  const {
    tituloGeneral,
    referenciaPlantillaContenido,
    nombreCategoria,
    tituloBoton,
    redireccionBoton,
  } = props;

  const getCard = (_card: ReferenciaPlantillaContenido, _i: number) => {
    return (
      <CardNews
        key={`card${_i}`}
        imgSrc={_card.imagenPrincipal && _card.imagenPrincipal[0].file.url}
        imgAlt={_card.imagenPrincipal && _card.imagenPrincipal[0].title}
        title={
          _card.descripcion && documentToReactComponents(_card.descripcion.json)
        }
        link={_card.redireccionBoton}
        label={_card.tituloBanner}
        gtmMark={`gtm${normalizeTwoWords(nombreCategoria)}${normalizeTwoWords(
          tituloGeneral
        )}${normalizeTwoWords(_card.tituloBanner)}Tarjeta${_i}`}
        modeGallery={true}
      />
    );
  };

  const seeAll = () => {
    navigate(`/ver-todo/?title=${tituloGeneral || "Artículos"}` +
    `&searchType=filter` +
    `&contentType=Artículos` + 
    `&searchParam=word,contentType` +
    `&paramValues=${redireccionBoton}/-artículo`,
     {
      state: {},
    });
  };

  return (
    <div className="o-gallery-cards">
      <div className="o-gallery-cards__title-section">
        <h2 className="o-gallery-cards__title title-secondary">
          {" "}
          {tituloGeneral}{" "}
        </h2>
        {tituloBoton && (
          <p
            className={`o-gallery-cards__title-section__see-all gtm${normalizeTwoWords(
              nombreCategoria
            )}${normalizeTwoWords(tituloGeneral)}${normalizeTwoWords(
              tituloBoton
            )}`}
            onClick={() => seeAll()}
          >
            {tituloBoton}
          </p>
        )}
      </div>
      <div className="o-gallery-cards__cont">
        <LayoutSlider
          nSlides={3}
          customClass={"o-gallery-cards__slider"}
          widthRelative={true}
        >
          {referenciaPlantillaContenido &&
            referenciaPlantillaContenido.map((card, i) => getCard(card, i))}
        </LayoutSlider>
      </div>
    </div>
  );
};

export default GalleryCards;
